<template>
  <div class="customer-service-container">
    <div class="con">
      <!-- 标签切换 -->
      <el-tabs v-model="activeRoleType" @tab-click="handleTabClick" class="service-tabs">
        <el-tab-pane label="厂家客服" name="administrator" ></el-tab-pane>
        <el-tab-pane label="维保客服" name="maintenance" v-if="website.roleType == 'shop'"></el-tab-pane>
      </el-tabs>

      <el-form
        label-position="right"
        size="small"
        class="form"
        label-width="180px"
        ref="formRef"
        :model="form"
      >
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name" readonly class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="form.phone" readonly class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="WHATSAPP：" prop="whatsapp">
          <el-input v-model="form.whatsapp" readonly class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="微信二维码：" prop="wechatQrCode">
          <div class="qr-code-display">
            <img v-if="form.wechatQrCode" :src="form.wechatQrCode" class="qr-code-preview-display" />
            <div v-else class="qr-code-placeholder-display">
              <i class="el-icon-picture"></i>
              <span>暂无二维码</span>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <!-- 底部编辑按钮 -->
      <div class="form-footer">
        <el-button type="primary" @click="openEdit" icon="el-icon-edit" v-if="website.roleType == 'factory'">编 辑</el-button>
      </div>

      <!-- 编辑对话框 -->
      <el-dialog
        title="修改信息"
        :visible.sync="dialogVisible"
        width="500px"
        center
        :before-close="onCancel"
      >
        <el-form :model="editForm" ref="editFormRef" label-width="120px" :rules="rules">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="WHATSAPP：" prop="whatsapp">
            <el-input v-model="editForm.whatsapp" placeholder="请输入WHATSAPP"></el-input>
          </el-form-item>
          <el-form-item label="微信二维码：" prop="wechatQrCode">
            <el-upload
              class="qr-code-uploader"
              action=""
              :auto-upload="false"
              :on-change="handleQrCodeChange"
              :show-file-list="false"
              accept="image/*"
              :before-upload="beforeUpload"
            >
              <img v-if="editForm.wechatQrCode" :src="editForm.wechatQrCode" class="qr-code-preview" />
              <i v-else class="el-icon-plus qr-code-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">点击上传二维码图片</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="submitEdit" :loading="submitting">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import website from "@/config/website";
import { uploadFile } from '@/api/announcement/index'
import { customerServiceCenter, customerServiceCenterUpdate } from '@/api/addDevice'

export default {
  name: 'CustomerServiceCenter',
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    return {
      activeRoleType: 'administrator', // 当前选中的客服类型
      form: {
        name: '',
        phone: '',
        whatsapp: '',
        wechatQrCode: ''
      },
      editForm: {
        name: '',
        phone: '',
        whatsapp: '',
        wechatQrCode: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        whatsapp: [
          { required: false, message: '请输入WHATSAPP', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      submitting: false
    }
  },
  created() {
    this.getCustomerInfo('administrator');
  },
  methods: {
    // 标签切换处理
    handleTabClick(tab) {
      this.activeRoleType = tab.name;
      this.form={
        id: '',
        name: '',
        phone: '',
        whatsapp: '',
        wechatQrCode: ''
      };
      this.getCustomerInfo(tab.name);
    },
    // 获取客服信息
    async getCustomerInfo(e) {
      console.log(e)
      const res = await customerServiceCenter({ roleType: e });
      if (res.data && res.data.code === 200) {
        this.form = res.data.data;
      }
    },
    // 打开编辑对话框
    openEdit() {
      this.editForm = {
        id: this.form.id,
        name: this.form.name,
        phone: this.form.phone,
        whatsapp: this.form.whatsapp,
        wechatQrCode: this.form.wechatQrCode
      };
      this.dialogVisible = true;
    },
    // 上传前验证
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    async handleQrCodeChange(file, fileList) {
      try {
        const formData = new FormData();
        formData.append('file', file.raw);
        const res = await uploadFile(formData);
        if (res.data && res.data.code === 200) {
          this.editForm.wechatQrCode = res.data.data.link;
          this.$message.success('上传成功');
        } else {
          this.$message.error(res.data.message || '上传失败');
        }
      } catch (error) {
        console.error('上传失败:', error);
        this.$message.error('上传失败');
      }
    },
    // 提交编辑
    async submitEdit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (valid) {
          this.submitting = true;
          try {
            const res = await customerServiceCenterUpdate({...this.editForm});
            if (res.data && res.data.code === 200) {
              this.$message.success('保存成功');
              this.onCancel();
              this.getCustomerInfo();
            } else {
              this.$message.error(res.data.message || '保存失败');
            }
            } catch (error) {
              console.error('保存失败:', error);
              this.$message.error('保存失败');
            } finally {
              this.submitting = false;
          }
        } else {
          this.$message.warning('请完善表单信息');
          return false;
        }
      });
    },
    // 取消编辑
    onCancel() {
      this.dialogVisible = false;
      this.$refs.editFormRef && this.$refs.editFormRef.resetFields();
      this.editForm = {
        name: '',
        phone: '',
        whatsapp: '',
        wechatQrCode: ''
      };
    }
  }
}
</script>

<style scoped>
.customer-service-container {
  padding: 40px 20px 20px;
  min-height: calc(100vh - 100px);
}

.con {
  width: 100%;
  max-width: 600px;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.service-tabs {
  margin-bottom: 20px;
}

.form {
  width: 100%;
}

.form-input {
  width: 100%;
}

.qr-code-display {
  display: inline-block;
}

.qr-code-preview-display {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.qr-code-placeholder-display {
  width: 178px;
  height: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  color: #999;
  background: #fafafa;
}

.qr-code-placeholder-display i {
  font-size: 32px;
  margin-bottom: 8px;
}

.qr-code-placeholder-display span {
  font-size: 12px;
}

.form-footer {
  margin-top: 30px;
  text-align: center;
}

.qr-code-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.qr-code-uploader ::v-deep .el-upload:hover {
  border-color: #409EFF;
}

.qr-code-uploader .qr-code-preview {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.qr-code-uploader .qr-code-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.upload-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}

.dialog-footer {
  text-align: right;
}
</style>
